import Field from "@mirage/components/regularField/Field";
import { convertBooleanToYesNo } from "@mirage/utilities/convertBooleanToYesNo";
import Grid from "@mui/material/Grid";
import { IPlanningApplicationDetails } from "@shared/publicportal/contracts/IPlanningApplicationDetails";
import React, { memo } from "react";
import "../PlanningApplication.css";

interface PASummaryTabContentProps {
    planningApp: IPlanningApplicationDetails | null;
    loading: boolean;
}

const PASummaryTabContent: React.FC<PASummaryTabContentProps> = memo((props) => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
                <Grid>
                    <Field label="Reference" mode="view" value={props.planningApp?.name} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Initial Reference" mode="view" value={props.planningApp?.initialAppRef} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Application Type" mode="view" value={props.planningApp?.applicationType?.name} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Proposal Details" mode="view" value={props.planningApp?.proposal} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Status" mode="view" value={props.planningApp?.applicationStatus} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Address" mode="view" value={`${props.planningApp?.location}`} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Ward" mode="view" value={props.planningApp?.ward} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Parish" mode="view" value={props.planningApp?.parish} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Easting" mode="view" value={props.planningApp?.easting} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Northing" mode="view" value={props.planningApp?.northing} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Case Officer" mode="view" value={props.planningApp?.caseOfficer?.name} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Decision" mode="view" value={props.planningApp?.decision} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Decision Level" mode="view" value={props.planningApp?.decisionLevel} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Appeal Decision" mode="view" value={props.planningApp?.appealDecision} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Applicant Name" mode="view" value={props.planningApp?.applicantFullName} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Applicant Address" mode="view" value={props.planningApp?.applicantAddress} isLoading={props.loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field
                        label="Environmental Statement Required"
                        mode="view"
                        value={convertBooleanToYesNo(props.planningApp?.environmentalStatementRequired)}
                        isLoading={props.loading}
                        contentType="TEXT"
                    />
                </Grid>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }} className="grid-nextItem">
                <Grid>
                    <Field label="Received Date" mode="view" value={props.planningApp?.receivedDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Registered Date" mode="view" value={props.planningApp?.registeredDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Valid Date" mode="view" value={props.planningApp?.validDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Weekly List Date" mode="view" value={props.planningApp?.weeklyListDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Response Deadline Date" mode="view" value={props.planningApp?.publicResponseDeadline} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Expiry Date" mode="view" value={props.planningApp?.expiryDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Decision Date" mode="view" value={props.planningApp?.decisionDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Appeal Decision Date" mode="view" value={props.planningApp?.appealDecisionDate} isLoading={props.loading} contentType="DATE" hideOnEmpty />
                </Grid>
            </Grid>
        </Grid>
    );
});

export default React.memo(PASummaryTabContent);
